import { useDeepEqualMemo } from '@carvana/merch-react-hooks';
import { useEffect } from 'react';
import { useDeviceType } from '~/context/common/DeviceContext';
import {
  useDealershipAddress,
  useDealershipConfiguration,
  useDealershipId
} from '~/context/dealership/StaticContext';
import type { EventVehicle } from '~/contracts/dealership';
import usePushToAdobe from '~/hooks/dealership/usePushToAdobe';
import getAdobeEventPageName from '~/utilities/dealership/getAdobeEventPageName';
import getAdobeEventPageType from '~/utilities/dealership/getAdobeEventPageType';

type Extras = {
  vehicle?: EventVehicle;
};

export default function useTrackAdobePageLoadEvent(
  shouldPush: boolean,
  extras: Extras = {}
) {
  const { zip } = useDealershipAddress();
  const { name: dealershipName } = useDealershipConfiguration();
  const dealershipId = useDealershipId();
  const deviceType = useDeviceType();
  const vehicleToUse = useDeepEqualMemo(extras.vehicle);
  const pushToAdobe = usePushToAdobe();

  useEffect(() => {
    if (!shouldPush) return;

    const eventPageType = getAdobeEventPageType();
    const eventPageName = getAdobeEventPageName(eventPageType, {
      vehicle: vehicleToUse
    });

    pushToAdobe({
      event: 'page-load',
      page: {
        type: eventPageType,
        name: eventPageName,
        site: 'dealer'
      },
      platform: { technology: 'other' },
      user: {
        language: navigator.language,
        responsiveState: deviceType.isDesktop
          ? 'desktop'
          : deviceType.isTablet
          ? 'tablet'
          : 'mobile',
        zipCode: zip,
        authentication: false
      },
      dealer: {
        code: dealershipId,
        provider: 'carvana',
        name: dealershipName
      },
      vehicle: vehicleToUse
    });
  }, [
    dealershipId,
    dealershipName,
    deviceType.isDesktop,
    deviceType.isTablet,
    pushToAdobe,
    shouldPush,
    vehicleToUse,
    zip
  ]);
}
